module.exports = __webpack_public_path__ + "img/Empty_NoData.4918b54c.png";